import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingService } from '../services/settingService';
import { imageService } from '../services/imageService';

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    contact_address: '60B Nguyễn Huy Tưởng, P. Thanh Xuân, Hà Nội',
    contact_email: 'thethaoltd@gmail.com',
    contact_phone_cskh: '0866863865',
    contact_phone_hr: '0989729095',
    csr_tu_thuoc: '425',
    csr_diem_truong: '425',
    csr_em_nho: '23671',
    jobs_default_email: 'tuyendung@thethaopharma.vn',
    jobs_default_phone: '0989.729.095'
  });

  const [images, setImages] = useState([]);

  const refreshSettings = () => {
    settingService
      .getAll()
      .then((res) => {
        if (res.data?.map) {
          setSettings((prev) => ({ ...prev, ...res.data.map }));
        }
      })
      .catch(() => { });
  };

  const refreshImages = () => {
    imageService
      .getAll()
      .then((res) => {
        if (res.data) {
          setImages(res.data);
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    refreshSettings();
    refreshImages();
  }, []);

  const getImage = (zone, slot = 0, fallback = '') => {
    const row = images.find((img) => img.zone === zone && Number(img.slot) === Number(slot));
    return row?.url || fallback;
  };

  return (
    <SiteContext.Provider value={{ settings, images, getImage, refreshSettings, refreshImages }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
